// Module
var code = "<template>\r\n\t<div>\r\n\t\t<slot name=\"content\"></slot>\r\n\t</div>\r\n</template>\r\n";
// Exports
module.exports = code;